import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ApproachSection from "@/components/ApproachSection";
import ResearchSection from "@/components/ResearchSection";
import SuccessStoriesSection from "@/components/SuccessStoriesSection";
import CommunitySection from "@/components/CommunitySection";
import MembershipSection from "@/components/MembershipSection";
import WhyICSSection from "@/components/WhyICSSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import JoinDiscordLanding from "@/components/JoinDiscordLanding";
import ReportSection from "@/components/ReportSection";

function HomePage() {
  return (
    <>
      <HeroSection />
      <ApproachSection />
      <ResearchSection />
      <SuccessStoriesSection />
      <CommunitySection />
      <MembershipSection />
      <WhyICSSection />
      <FAQSection />
      <ContactSection />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/join-discord" element={<JoinDiscordLanding />} />
          <Route path="/join-disocord" element={<JoinDiscordLanding />} />
          <Route path="*" element={
            <>
              <Navigation />
              <main>
                <Routes>
                  <Route path="/report" element={<Navigate to="/report/nasdaq" replace />} />
                  <Route path="/report/nasdaq" element={<ReportSection />} />
                  <Route path="/report/psx" element={<ReportSection />} />
                  <Route path="/report/tasi" element={<ReportSection />} />
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
